import { render, staticRenderFns } from "./AgentServiceTranslationSwitch.vue?vue&type=template&id=3921b58d&scoped=true"
import script from "./AgentServiceTranslationSwitch.vue?vue&type=script&lang=js"
export * from "./AgentServiceTranslationSwitch.vue?vue&type=script&lang=js"
import style0 from "./AgentServiceTranslationSwitch.vue?vue&type=style&index=0&id=3921b58d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3921b58d",
  null
  
)

export default component.exports